import "./Login.css";
import api from '../api.js';
import { useState, useEffect } from "react";
import wave from '../imgs/wave_logo.svg';
import allLogos from '../imgs/allLogos1.svg';
import waveText from '../imgs/waveText.svg';

export default function Login({ onLogin }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");

  const handleLogIn = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/api/auth/login", { login, password, rememberMe });
    //   const token = response.data.token;
         const meRes = await api.get("/api/auth/me");
    //   localStorage.setItem("token", token);
      localStorage.setItem("login", login);

    localStorage.setItem("me", JSON.stringify(meRes.data));
    //   if (onLogin) onLogin(token, login);
          if (onLogin) onLogin(login);
    } catch (err) {
      if (err.response) setError(typeof err.response.data === "string" ? err.response.data : err.response.data.message || "Ошибка при входе");
      else setError("Ошибка сети или сервера");
    }
  };

  useEffect(() => { document.title = "Войти - Wave"; }, []);

    return (
        <div className="loginScreen">

            <div className="loginContainer">
                <div className="loginContainerContents">
                    <img src={wave} className="logoWave" />
                    <h1>Вход в систему</h1>
                    <form onSubmit={handleLogIn}>
                        <div className="inputWrapper">
                            <input id="loginInput" className={error ? "loginInputError" : "loginInput"} required type="text" placeholder="Логин" value={login} onChange={(e) => setLogin(e.target.value)} />
                            <label htmlFor="loginInput" className="loginLabel"></label>
                        </div>
                        <div className="inputWrapper">
                            <input id="passwordInput" className={!error ? "passwordInput" : "passwordInputWithError"} required type="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)} />
                            <label htmlFor="passwordInput" className="passwordLabel"></label>
                        </div>
                        <div className="rememberMe">
                            <label className="customCheckbox">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                />
                                <span className="checkmark"></span>
                                Запомнить меня
                            </label>
                        </div>
                        {error && <p style={{ color: "red", margin: 0, padding: 0, marginBottom: 9 }}>{error}</p>}
                        <button type="submit" className={error ? "submitError" : "submitNoError"}>Войти</button>
                    </form>

                    <p className="contactAdmin">Проблемы со входом? <a href="#">Обратиться к администратору</a></p>
                    <img src={waveText} className="waveTextBottom" />
                </div>
            </div>


            <div className="loginRightSide">
                <img className="logos" src={allLogos} />
            </div>
        </div>
    );
}
